export default "__VITE_ASSET__B0s1uGXZ__"